import React from 'react';
import { Dialog } from "@headlessui/react";
import CustomDialog from "../basic/Dialog";
import { Icon } from "@iconify/react";

const PopupMsg = () => {
    return (
        // <CustomDialog >
        //     <Dialog.Panel>
        // <div
        //     className="cursor-pointer bg-[#d9d9d9] rounded-full absolute -right-2 md:-right-5 -top-2 md:-top-5 w-10 h-10 justify-center items-center flex"
        // >
        //     <Icon icon="carbon:close" className="h-6 w-6" />
        // </div>

        <div className="grid grid-col-1 lg:grid-cols-2 gap-10 h-full text-white md:mx-28 mx-12 md:my-10 my-6 md:px-8 px-4 md:py-9 py-5 bg-gradient-to-br to-[#2A2A35] from-[#494959]">
            <div className='grid grid-rows-2 bg-[#282830] h-80'>
                <div className='grid grid-cols-3 justify-center md:mx-20 mx-6 mt-3 md:mt-6 -mb-20 gap-4 md:h-16 h-12 w-44 md:w-56'>
                    <p className='bg-[#000000] text-white text-xs flex justify-center items-center text-opacity-60'>Goal 1</p>
                    <p className='bg-[#000000] text-white text-xs flex justify-center items-center text-opacity-60'>Goal 2</p>
                    <p className='bg-[#000000] text-white text-xs flex justify-center items-center text-opacity-60'>Goal 3</p>
                </div>
                <div className='h-full grid md:grid-rows-4 grid-row-1 md:mx-12 mx-6 -my-6 bg-[#000000] px-6 py-4'>
                    <p className='text-white text-xs md:text-sm font-bold font-poppins'>Get started with A<br /><span className='text-primary-neonGreen'>Trainer-made Program</span>
                        <div className='bg-gradient-to-br to-[#2A2A35] from-[#494959] w-1/5 md:w-1/3 h-1/5 bg-opacity-30 my-1'></div>
                    </p>
                    <div className='bg-gradient-to-br to-[#2A2A35] from-[#494959] w-1/5 md:w-1/3 h-1 md:h-1/6 mt-8 md:my-12 bg-opacity-30'></div>
                    <div className='bg-gradient-to-br to-[#2A2A35] from-[#494959] w-1/5 md:w-1/3 h-1 md:h-1/6 mt-1 md:my-8 bg-opacity-30'></div>
                    <div className='grid md:grid-cols-2 grid-cols-1'>
                        <div className='bg-gradient-to-br to-[#2A2A35] from-[#494959] w-2/5 md:w-2/3 h-1 md:h-1/6 bg-opacity-30 my-1 md:my-4'></div>
                        <button className='flex content-end md:ml-10 bg-primary-neonGreen rounded-sm text-[#000000] text-xs items-center justify-center w-28 h-5 md:w-32 md:h-7'>Customize Now</button>
                    </div>
                </div>
            </div>
            <div className='grid grid-rows-3 md:px-10 px-4'>
                <p className='text-[#C3F73A] text-2xl md:text-5xl font-bold font-poppins'>Welcome <span className='text-white text-2xl md:text-5xl font-bold font-poppins'>to the <br /><span>new interface</span> </span> </p>
                <p className='text-sm text-white sm:-mt-2 mb-4'>Getactyv is growing and getting stronger everyday. We are back with a new set of features and UI. As part of this change, we have unified all your goals into one single better effective program.</p>
                <button className='bg-[#C3F73A] text-[#282830] text-sm rounded-md md:w-52 w-40 md:h-12 h-8 font-sans'>Sounds good!</button>
            </div>
        </div>

        //     </Dialog.Panel>
        // </CustomDialog>

    );
}

export default PopupMsg;



